"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchIconPadding = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Input_1 = __importDefault(require("../Input"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var SearchInputContent_1 = require("./SearchInputContent");

var SearchIconPadding;

(function (SearchIconPadding) {
  SearchIconPadding["sm"] = "30px";
  SearchIconPadding["md"] = "50px";
  SearchIconPadding["lg"] = "50px";
  SearchIconPadding["xl"] = "65px";
})(SearchIconPadding || (exports.SearchIconPadding = SearchIconPadding = {}));

var SearchInput = function SearchInput(_a) {
  var language = _a.language,
      props = __rest(_a, ["language"]);

  var _ref = (0, frontend_theme_1.useTheme)(),
      theme = _ref.theme;

  var lighterGray = theme.colors.primary.lighterGray;
  var size = props.size || "md";
  return (0, jsx_runtime_1.jsx)(Input_1.default, Object.assign({
    placeholder: SearchInputContent_1.SearchInputContent[language].placeholderText,
    background: lighterGray,
    border: false,
    addStyle: {
      paddingRight: SearchIconPadding[size]
    }
  }, props, {
    icon: props.icon || "search",
    inputType: "search",
    language: language,
    autoComplete: "off"
  }));
};

exports.default = SearchInput;